module.exports = __webpack_public_path__ + "assets/img/3.c54e8f2b.png";